import React, {Component} from "react"
import Papa from "papaparse"

import {Label} from "@irati/ui/src/Typography"
import {FormattedMessage, injectIntl, InjectIntl} from "@irati/utils/lang"
import Flex from "@irati/ui/src/Flex"
import Button from "@irati/ui/src/Button"
import makeCSV from "@irati/utils/csv/makeCSV"
import adminTracking from "@irati-tracking/admin/admin"

interface Props extends InjectIntl {
  summary: any
}

class OrganisationalSummaryDownload extends Component<Props> {
  downloadReport = () => {
    adminTracking.analyticsEngagementDownloadReport()
    const {formatMessage, summary} = this.props
    const orgSummaryData = summary.reduce((arr, t) => {
      if (t.currency) {
        const currency = {
          title: "admin.reporting.orgSummary.currency",
          value: t.currency
        }
        const value = {
          title: t.title,
          value: t.unformattedValue ? t.unformattedValue.toFixed(0) : "-"
        }
        return [...arr, currency, value]
      }
      return [...arr, t]
    }, [])

    const headers = orgSummaryData.map(({title}) => formatMessage({id: title}))
    const data = orgSummaryData.map(({value}) => value)
    const csv = Papa.unparse({fields: headers, data})
    makeCSV(csv, "organisationalSummary.csv")
  }

  render() {
    return (
      <Flex justifyContent="space-between" alignItems="center" marginTop={1}>
        <Label>
          <FormattedMessage id="admin.reporting.popularPerks.dataInfo" />
        </Label>
        <Button primary onClick={this.downloadReport} id="adminSection_reporting_downloadOrgSummary_button">
          <FormattedMessage id="admin.reporting.button.downloadReport" />
        </Button>
      </Flex>
    )
  }
}

export default injectIntl(OrganisationalSummaryDownload)
